import type { ActionFunctionArgs } from '~/types/route-args';

import { requestEmailLoginCodeAction } from '~/modules/user/email-login/email-login-landing.server';

export const REQUEST_EMAIL_LOGIN_CODE_API_ROUTE =
    '/remix-api/user/request-email-login-code';

export const action = (args: ActionFunctionArgs) =>
    requestEmailLoginCodeAction(args);

export type RequestEmailLoginCodeAction =
    | { ok: true }
    | { ok: false; message: string };
